module.exports = __webpack_public_path__ + "static/media/twitter.4652a67e.png";